import * as React from "react";
import { connect } from "react-redux";
import * as types from "../../constants/actionTypes";
import { Map, InfoWindow, Marker, GoogleApiWrapper } from 'google-maps-react';
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";

class LocationDetailsMap extends React.Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {

    }

    componentWillReceiveProps(nextProps) {

    }

    render() {
        const { selectedLoc, mapCenter, getDirections, onMapClicked } = this.props;
        let mapCenterCoordinates = { lat: 0, lng: 0 };
        mapCenterCoordinates = mapCenter ? mapCenter : { lat: selectedLoc.coordinates.lat, lng: selectedLoc.coordinates.lon };

        const mapStyles = [
            {
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#53575a"
                    }
                ]
            },
            {
                "featureType": "administrative.neighborhood",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#74ded4"
                    }
                ]
            },
            {
                "featureType": "landscape.man_made",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#e6eaee"
                    }
                ]
            },
            {
                "featureType": "landscape.man_made",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#53575a"
                    }
                ]
            },
            {
                "featureType": "landscape.natural",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#e6eaee"
                    }
                ]
            },
            {
                "featureType": "landscape.natural",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "landscape.natural.landcover",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#e6eaee"
                    }
                ]
            },
            {
                "featureType": "landscape.natural.terrain",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#00c5b3"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#74ded4"
                    }
                ]
            },
            {
                "featureType": "poi.attraction",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#74ded4"
                    }
                ]
            },
            {
                "featureType": "poi.business",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#74ded4"
                    }
                ]
            },
            {
                "featureType": "poi.business",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#53575a"
                    }
                ]
            },
            {
                "featureType": "poi.government",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#74ded4"
                    }
                ]
            },
            {
                "featureType": "poi.medical",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#d5dde4"
                    }
                ]
            },
            {
                "featureType": "poi.medical",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#53575a"
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#74ded4"
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#53575a"
                    }
                ]
            },
            {
                "featureType": "poi.place_of_worship",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#74ded4"
                    }
                ]
            },
            {
                "featureType": "poi.place_of_worship",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#525659"
                    }
                ]
            },
            {
                "featureType": "poi.school",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#e6eaee"
                    }
                ]
            },
            {
                "featureType": "poi.school",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#53575a"
                    }
                ]
            },
            {
                "featureType": "poi.sports_complex",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#74ded4"
                    }
                ]
            },
            {
                "featureType": "poi.sports_complex",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#53575a"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#fdfefe"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "color": "#f9dc90"
                    }
                ]
            },
            {
                "featureType": "transit.station.airport",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#d5dde4"
                    }
                ]
            },
            {
                "featureType": "transit.station.airport",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#53575a"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#00c1e0"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "labels.text",
                "stylers": [
                    {
                        "color": "#fafafb"
                    }
                ]
            }
        ];

        return (
            <Map google={this.props.google} zoom={15}
                styles={mapStyles}
                onClick={() => onMapClicked(this.props)}
                initialCenter={mapCenterCoordinates}
                center={mapCenterCoordinates}
            >
                <Marker key={selectedLoc.locationID}
                    name={selectedLoc.locationName}
                    id={selectedLoc.locationID}
                    position={mapCenterCoordinates}
                    icon={{ url: "../../../images/map-pin.svg", anchor: new google.maps.Point(0, 42), scaledSize: new google.maps.Size(32, 42) }}
                    onClick={(props, marker, e) => { getDirections(selectedLoc); }}
                />
            </Map>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        googleMapKey: state.session.serverData.googleMapKey,
        userLatitude: state.locations.latitude,
        userLongitude: state.locations.longitude,
        ...ownProps
    };
};

const LocationDetailsMapComp = GoogleApiWrapper((props) => ({
    apiKey: props.googleMapKey
}))(LocationDetailsMap);

export default connect(mapStateToProps)(LocationDetailsMapComp);
